import React from 'react';
import { Link } from 'react-router-dom';

const TabButton = (props) => {
	if (props.path) {
		return (
			<Link
				to={props.path}
				onClick={props.onClick}
				className={'nav-link' + (props.isActive ? ' active' : '')}
				style={props.right ? { marginLeft: 'auto' } : {}}
			>
				{props.text}
			</Link>
		);
	}
	return (
		<button
			onClick={props.onClick}
			className={'nav-link' + (props.isActive ? ' active' : '')}
			style={props.right ? { marginLeft: 'auto' } : {}}
		>
			{props.text}
		</button>
	);
};

export default TabButton;